import React from 'react';

const SimpleSpinnerForever = () => (
  <div className={`simple-spinner display`}>
    <div className="circle" />
  </div>
);

export default SimpleSpinnerForever;
